import React, { useEffect, useMemo, useState } from "react";
import {
  Paper,
  Grid,
  Typography,
  TextField,
  MenuItem,
  InputAdornment,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Stack,
  TableContainer,
  Pagination,
  Tooltip,

  useMediaQuery,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import axios from "axios";

import CategoryDialog from "./CategoryDialog";
import categoriesApi from "../../hooks/GET/categories";
import { endpoint } from "../../config";
import { customToast } from "../../lib/toastLib";
import ConfirmationDialog from "../../components/ConfirmationDialog";

function Category() {
  // category list logic start
  const [categoryList, setCategoryList] = useState([]);
  const [refetchCategoryList, setRefetchCategoryList] = useState(0);
  const [totalResult, setTotalResult] = useState(0);
  const isSmall = useMediaQuery('(max-width:536px)');
  const isSmall2 = useMediaQuery('(max-width:600px)');

  useEffect(() => {
    categoriesApi()
      .then((data) => {
        setCategoryList(data);

      })
      .catch((error) => console.log(error));
  }, [refetchCategoryList]);

  const handleDelete = (id) => {
    const fieldValues = [...categoryList];
    // const index = page * rowsPerPage + i;
    axios
      .delete(`${endpoint}/api/category/${id}`)
      .then(() => {

        fieldValues.splice(fieldValues.findIndex(obj => obj.id === id), 1);


        setCategoryList(fieldValues);


        // if (totalResult !== 0) {
        //   const lastPage = Math.ceil(totalResult / rowsPerPage);

        //   if (lastPage === page)
        //     setPage(lastPage - 1);

        // }

        customToast.success("Category deleted successfully");
      })
      .catch((error) => {
        if (error.response) {
          customToast.error(error.response.data?.message);
        } else {
          customToast.error(error.message);
        }
      });
  };
  // category list logic end

  //table pagination logic start
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const rowsPerPageOption = [5, 10, 20];

  const handleChangePage = (e, newPage) => {
    setPage(newPage - 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  const emptyRows = rowsPerPage -
    Math.min(rowsPerPage, totalResult - page * rowsPerPage);
  // rowsPerPage -
  // Math.min(rowsPerPage, categoryList.length - page * rowsPerPage);
  //table pagination logic end

  // category dialog logic start
  const [categoryDialogState, setCategoryDialogState] = useState({
    open: false,
    id: 0,
    name: "",
    description: "",
  });

  const handleCategoryDialogOpen = (id, name, description) => {
    setCategoryDialogState({
      open: true,
      id: id,
      name: name,
      description: description,
    });
  };

  const handleCategoryDialogClose = (doRefetch) => {
    if (doRefetch) {
      setRefetchCategoryList(refetchCategoryList + 1);
    }
    setCategoryDialogState({ open: false, id: 0, name: "", description: "" });
  };
  // category dialog logic end

  // delete confirmation dialog logic start
  const [deleteDialogState, setDeleteDialogState] = useState({
    open: false,
    title: "",
    message: "",
    id: "",
  });

  const handleDeleteDialogOpen = (title, message, id) => {
    setDeleteDialogState({
      open: true,
      title: title,
      message: message,
      id: id,
    });
  };

  const handleDeleteDialogClose = (isConfirmed, id) => {
    // if confirmed than delete
    if (isConfirmed) {
      handleDelete(id);
    }
    setDeleteDialogState({
      open: false,
      title: "",
      message: "",
      id: "",
    });
  };
  // delete confirmation dialog logic end

  // search logic start
  const [search, setSearch] = useState("");

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearch(value);
    setPage(0);
  };

  const getFilteredCategoryList = useMemo(() => {
    let filterdata = categoryList;

    filterdata = filterdata.filter((obj) =>
      JSON.stringify(obj).match(new RegExp(search, "gi"))
    );
    setTotalResult(filterdata.length);

    if (filterdata.length !== 0) {
      const lastPage = Math.ceil(filterdata.length / rowsPerPage);
      if (lastPage === page)
        setPage(lastPage - 1);
    }

    return filterdata;
  }, [search, categoryList, page, rowsPerPage]);
  // search logic end

  return (

    <Paper variant="outlined" sx={{ padding: 2 }}>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        spacing={2}

      >

        <Grid item >
          <Typography sx={{ display: "contents" }}>Show</Typography>
          <TextField
            select
            name="rowsPerPage"
            value={rowsPerPage}
            onChange={handleChangeRowsPerPage}
            size="small"
            sx={{ verticalAlign: "middle", margin: 1, minWidth: 75 }}
          >
            {rowsPerPageOption.map((option, idx) => (
              <MenuItem key={idx} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
          <Typography sx={{ display: "contents" }}>entries</Typography>
          <TextField
            name="search"
            value={search}
            onChange={handleSearchChange}
            placeholder="Search..."
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            sx={{ verticalAlign: "middle", marginLeft: isSmall ? 0 : 1, marginTop: 1, marginRight: isSmall ? 2 : 1, marginBottom: 1 }}
          />
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => handleCategoryDialogOpen(null, "", "")}
          >
            Create
          </Button>
        </Grid>
      </Grid>

      {/* Table part */}
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center">Sr. No.</TableCell>
              <TableCell align="center">Name</TableCell>
              <TableCell align="center">Description</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? getFilteredCategoryList.slice(
                page * rowsPerPage,
                page * rowsPerPage + rowsPerPage
              )
              : getFilteredCategoryList
            ).map((fieldValue, idx) => (
              <TableRow key={idx} hover>
                <TableCell align="center">{page * rowsPerPage + idx + 1}</TableCell>
                <TableCell align="center">{fieldValue.name}</TableCell>
                <TableCell align="center">{fieldValue.description}</TableCell>
                <TableCell align="center">
                  <Stack direction="row" justifyContent="center">
                    <Tooltip title="Edit">
                      <IconButton
                        size="small"
                        color="secondary"
                        onClick={() =>
                          handleCategoryDialogOpen(
                            fieldValue.id,
                            fieldValue.name,
                            fieldValue.description
                          )
                        }
                      >
                        <EditOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() =>
                          handleDeleteDialogOpen(
                            `Delete category '${fieldValue.name}'`,
                            "Are you sure you want to delete this category?",
                            fieldValue.id
                          )
                        }
                      >
                        <DeleteOutlinedIcon />
                      </IconButton>
                    </Tooltip>
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
            {emptyRows > 0 && (
              <TableRow style={{ height: 53 * emptyRows }}>
                <TableCell align="center" colSpan={4}>
                  {totalResult === 0 &&
                    "No category available to display"}
                  {/* {categoryList.length === 0 &&
                    "No category available to display"} */}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <CategoryDialog
        open={categoryDialogState.open}
        handleClose={handleCategoryDialogClose}
        dataId={categoryDialogState.id}
        dataName={categoryDialogState.name}
        dataDescription={categoryDialogState.description}
      />

      <ConfirmationDialog
        open={deleteDialogState.open}
        handleClose={handleDeleteDialogClose}
        title={deleteDialogState.title}
        message={deleteDialogState.message}
        data={deleteDialogState.id}
      />

      {/* {categoryList.length > 0 && ( */}
      {totalResult > 0 && (
        <Grid container justifyContent="center" sx={{ mt: 2 }} spacing={1} wrap='nowrap'>
          <Grid item>
            <Button
              size="small"
              onClick={(e) => handleChangePage(e, page)}
              disabled={page === 0}
            >
              Previous
            </Button>
          </Grid>
          <Grid item>
            <Pagination
              // count={Math.ceil(categoryList.length / rowsPerPage)}
              count={Math.ceil(totalResult / rowsPerPage)}
              page={page + 1}
              onChange={handleChangePage}
              variant="outlined"
              shape="rounded"
              color="secondary"
              hidePrevButton
              hideNextButton
              size={isSmall2 ? 'small' : 'medium'}
            />
          </Grid>
          <Grid item>
            <Button
              size="small"
              onClick={(e) => handleChangePage(e, page + 2)}
              // disabled={
              //   Math.ceil(categoryList.length / rowsPerPage) === page + 1
              // }
              disabled={
                Math.ceil(totalResult / rowsPerPage) === page + 1
              }
            >
              Next
            </Button>
          </Grid>
        </Grid>
      )}
    </Paper>
  );
}

export default Category;
